import {
    IconHome,
    IconCalendarEvent,
    IconMail,
    IconFileUpload,
    IconFileInvoice,
    IconPhoneCall,
    IconAntennaBars5,
    IconChecklist,
    IconNotebook,
    IconPhoneCheck,
    IconUsers,
    IconSettings,
    IconCards,
    IconTicket,
    IconUser,
    IconMessageReport,
    IconDoorEnter,
} from '@tabler/icons';
import { IconReceiptRupee, IconHistory } from '@tabler/icons-react';
import i18n from 'i18n';

const icons = {
    IconHome,
    IconCalendarEvent,
    IconMail,
    IconFileUpload,
    IconFileInvoice,
    IconPhoneCall,
    IconAntennaBars5,
    IconChecklist,
    IconNotebook,
    IconPhoneCheck,
    IconUsers,
    IconSettings,
    IconCards,
    IconTicket,
    IconUser,
    IconMessageReport,
    IconDoorEnter,
    IconReceiptRupee,
    IconHistory
};
const adminDashboard = {
    title: i18n.t('Dashboard-Menu'),
    type: 'group',
    children: [
        {
            id: 'default',
            title: i18n.t('Dashboard'),
            type: 'item',
            url: '/dashboard/default',
            icon: icons.IconHome,
            breadcrumbs: false
        }, {
            id: '1',
            title: i18n.t('Company'),
            type: 'item',
            url: '/dashboard/company',
            icon: icons.IconUser,
            breadcrumbs: false
        }, {
            id: '2',
            title: i18n.t('Subscription'),
            type: 'item',
            url: '/dashboard/subscription',
            icon: icons.IconReceiptRupee,
            breadcrumbs: false
        }, {
            id: '3',
            title: i18n.t('Payment History'),
            type: 'item',
            url: '/dashboard/paymenthistory',
            icon: icons.IconHistory,
            breadcrumbs: false
        }, {
            id: '4',
            title: i18n.t('Report'),
            type: 'item',
            url: '/dashboard/report',
            icon: icons.IconMessageReport,
            breadcrumbs: false
        },
        {
            id: '5',
            title: i18n.t('Profile'),
            type: 'item',
            url: '/dashboard/profile',
            icon: icons.IconSettings,
            breadcrumbs: false
        }
    ]
};

export default adminDashboard;
